'use client';

import { useLocation } from '@reach/router';
import { Slice } from 'gatsby';
import React, { type FC, useContext, useEffect, useState } from 'react';

import { OutButton } from '@/components/buttons/out-button';
import { ThemeButton } from '@/components/buttons/theme-button';
import { ButtonLink } from '@/components/links/button-link';
import { ParamLink } from '@/components/links/param-link';
import { MediaQueryContext } from '@/context/media-query';
import { cn } from '@/utils/class-name';

export const Header: FC = () => {
    const location = useLocation();

    const resolution = useContext(MediaQueryContext);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        setIsActive(false);
    }, [location, resolution.desktop]);

    return (
        <header className={cn('header d-flex ai-center bg-white-gray', isActive && 'open')}>
            <div className="container d-flex ai-center g-16">
                <Slice alias="header-extra" />

                <ThemeButton />

                <div className="d-flex jc-end" style={{ flex: '1 1' }}>
                    <button
                        className="header-toggler d-lg-none"
                        aria-label={isActive ? 'Zamknij główną nawigację' : 'Otwórz główną nawigację'}
                        onClick={() => setIsActive(!isActive)}
                    >
                        <span></span>
                        {!isActive && <span></span>}
                        <span></span>
                    </button>
                </div>

                <nav className="header-panel bg-white-gray d-none d-lg-flex">
                    <ul className="list unstyled-list g-13 c-secondary container flex-lg-row ai-lg-center">
                        <li>
                            <ParamLink to="/prestamo-personal/" className="d-block">
                                Préstamo Personal
                            </ParamLink>
                        </li>

                        <li>
                            <ParamLink to="/prestamo-hipotecario/" className="d-block">
                                Préstamo Hipotecarios
                            </ParamLink>
                        </li>

                        <li>
                            <ParamLink to="/prestamo-rapido/" className="d-block">
                                Préstamo Rápido
                            </ParamLink>
                        </li>

                        <li>
                            <ParamLink to="/prestamo-coche/" className="d-block">
                                Préstamo Coche
                            </ParamLink>
                        </li>

                        <li className="d-none d-lg-block">
                            <OutButton theme="outline" className="small-button" url={location.pathname}>
                                Simular ahora
                            </OutButton>
                        </li>

                        <li>
                            <ButtonLink
                                theme="green"
                                style={{ minWidth: 'auto' }}
                                className="small-button"
                                target="_blank"
                                href="https://wa.me/34689479006"
                                rel="noopener noreferrer nofollow"
                            >
                                <img width="21" height="20" src="/assets/header/whats-app.svg" alt="WhatsApp" />
                            </ButtonLink>
                        </li>
                    </ul>
                </nav>
            </div>

            {isActive && <div className="header-close" onClick={() => setIsActive(!isActive)}></div>}
        </header>
    );
};
